// TODO UPDATE AT TERM 1 FLIP: move '+' to next grad cohort, remove old grad cohort and add next one, increase order
export const CLASS_OF_MAPPING = {
  '2021+': {
    key: '2021+',
    human: '2021+',
    filterValue: '2021+',
    filterKey: 'classOf',
    order: 0,
  },
  '2022': {
    key: '2022',
    human: '2022',
    filterValue: '2022',
    filterKey: 'classOf',
    order: 1,
  },
  '2023': {
    key: '2023',
    human: '2023',
    filterValue: '2023',
    filterKey: 'classOf',
    order: 2,
  },
  '2024': {
    key: '2024',
    human: '2024',
    filterValue: '2024',
    filterKey: 'classOf',
    order: 3,
  },
  '2025': {
    key: '2025',
    human: '2025',
    filterValue: '2025',
    filterKey: 'classOf',
    order: 4,
  },
  '2026': {
    key: '2026',
    human: '2026',
    filterValue: '2026',
    filterKey: 'classOf',
    order: 5,
  },
  '2027': {
    key: '2027',
    human: '2027',
    filterValue: '2027',
    filterKey: 'classOf',
    order: 6,
  },
  '2028': {
    key: '2028',
    human: '2028',
    filterValue: '2028',
    filterKey: 'classOf',
    order: 7,
  },
  '2029': {
    // follow up with Jamie https://github.com/NewVisionsForPublicSchools/nv-data-tools-portal/commit/6f10aa7ea265dc747575ef3658da07180e32328b#diff-731bff8ae7fa4925586560726c8cccfb
    key: '2029',
    human: '2029',
    filterValue: '2029',
    filterKey: 'classOf',
    order: 8,
  },
  None: {
    key: 'None',
    human: 'None',
    filterValue: 'None',
    filterKey: 'none',
    order: 9,
  },
};
